// extracted by mini-css-extract-plugin
export default {"container":"ZckOYJ","placeInfoContainer":"aaCHNt","ticketInfoContainer":"ckkXUp","ticketNameContainer":"ROKwbD","priceOptionTicketName":"ix4jDn"};